import { useCallback, useEffect, useRef, useState } from "react"
import { get } from "helpers/api_helper"

// „Lista organizatorului” of several organizers at once (Phase C2b's read): the selected one's for the review panel, and every included
// one's for "Review and send", which builds each sending from it. Each list is read again with every answer of its queue (`generation`),
// so a sending, a refusal or a reread shows the lists as they are now. Until the new answer lands the last one stays shown (as the
// calendar read), marked not `fresh`; an answer is kept only when it belongs to the latest read asked for.
export default function useOrganizerLists(paths, generation) {
  const [lists, setLists] = useState({})
  const [attempt, setAttempt] = useState(0)
  const requested = useRef({})
  const mounted = useRef(true)
  useEffect(() => () => { mounted.current = false }, [])
  const key = paths.join("|")
  useEffect(() => {
    paths.forEach(path => {
      if (requested.current[path] === generation) return
      requested.current[path] = generation
      const keep = entry => mounted.current && requested.current[path] === generation && setLists(current => ({ ...current, [path]: { generation, ...entry } }))
      get(path)
        .then(response => keep({ data: response?.data || null }))
        .catch(() => keep({ data: lists[path]?.data, error: "The organizer's list could not be loaded." }))
    })
  }, [key, generation, attempt]) // eslint-disable-line react-hooks/exhaustive-deps
  // Read again, at once: a failed read.
  const retry = useCallback(path => {
    delete requested.current[path]
    setAttempt(value => value + 1)
  }, [])
  const listOf = path => ({ ...lists[path], fresh: lists[path]?.generation === generation })
  return { listOf, retry }
}
